import { mergeActionDefinitions } from "../../../utils";

export default mergeActionDefinitions("ClassAnalytics", {
  exportAssessments: ["assessmentsTotal", "objectDisplayName", "courseDisplayName", "isXLSX"],
  fetchAllUsers: ["courseId", "classId"],
  fetchClassData: ["classId"],
  fetchCourseData: ["courseId"],
  fetchUsersAnalytics: ["courseId", "classId"],
  handleFetchAllUsersFailure: ["error"],
  handleFetchAllUsersSuccess: ["users"],
  handleFetchClassDataFailure: ["error"],
  handleFetchClassDataSuccess: ["class"],
  handleFetchCourseDataFailure: ["error"],
  handleFetchCourseDataSuccess: ["course"],
  handleFetchUsersAnalyticsFailure: ["error"],
  handleFetchUsersAnalyticsSuccess: ["usersAnalytics", "unitsAnalytics", "fetchClassPartInstSummaryRollup"],
  mount: ["courseId", "classId"],
  unmount: ["courseId", "classId"],
});
